function ProductInformation({ desc }) {
  return (
    <div className="product-information">
      {/* <h3>التفاصيل</h3>
      <ul >
        {desc ?
          (Object.keys(desc).map((info, index) => (
            <div key={index}>
              <li>{info}</li>
              <span className="col-2">{desc[info]}</span>
            </div>
          )))
          : <div></div>
        }
      </ul> */}
    </div>
  )
}
export default ProductInformation;